import { Controller, useFormContext } from "react-hook-form";
import { makeStyles, TextField } from "@material-ui/core";
import { ErrorMessage } from "@hookform/error-message";
import { FormControl } from "@mui/material";
import useFormPersist from "react-hook-form-persist";

import { PhoneNumberInput } from "components/PhoneNumberInput";
import { useStorage } from "hooks/useStorage";
import { IProps } from "../../types/types";
import styles from "../../styles/TextInput.module.scss";

const textFieldStyles = makeStyles(() => ({
  root: {
    "& .MuiFormLabel-root": {
      minHeight: "5rem",
      fontSize: "1.4rem",
      lineHeight: "normal",
      fontFamily: "Montserrat",
      fontWeight: 500,
    },
    "& label + .MuiInput-formControl": {
      marginTop: "32px",
    },
    "& .MuiInputBase-input": { fontSize: "1.5rem" },
  },
  MuiFormControl: {
    "& .MuiFormControl-root": { minWidth: "100%" },
  },
}));

export const TextInput = ({ id, name, label, required, component }: IProps) => {
  const { storageValue } = useStorage(id);

  const {
    register,
    control,
    trigger,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();
  useFormPersist("onboarding", { watch, setValue, storage: window.localStorage })


  const classes = textFieldStyles();
  const errorMessage = required && "Este campo debe ser completado";

  return (
    <div className={styles.formItem}>
      <div className={styles.form}>
        {component.type === "email" ? (
          <>
            <Controller
              control={control}
              {...register(name, {
                required: errorMessage,
                pattern: {
                  value: /^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/,
                  message: "Ingrese un correo válido",
                },
              })}
              name={name}
              defaultValue=""
              render={({ field: { onChange, name, value } }) => (
                <FormControl className={classes.MuiFormControl}>
                  <TextField
                    onKeyUp={() => trigger(name)}
                    className={classes.root}
                    id="standard-password-input"
                    label={label}
                    type={component.type}
                    name={name}
                    value={ !!value ? value : storageValue }
                    required={required}
                    onChange={onChange}
                    autoComplete={label}
                    variant="standard"
                  />
                </FormControl>
              )}
            />
            <ErrorMessage
              errors={errors}
              name={name}
              render={({ message }) => (
                <span className={styles.form__error}>{message}</span>
              )}
            />
          </>
        ) : component.type === "phone" ? (
          <>
            <PhoneNumberInput
              id={name}
              type={component.type}
              name={name}
              required={required}
            />
          </>
        ) : (
          <>
            <Controller
              control={control}
              {...register(name, {
                required: errorMessage,
              })}
              name={name}
              defaultValue=""
              render={({ field: { onChange, name, value } }) => (
                <FormControl className={classes.MuiFormControl}>
                  <TextField
                    onKeyUp={() => trigger(name)}
                    className={classes.root}
                    id="standard-password-input"
                    label={label}
                    type={component.type}
                    name={name}
                    value={ !!value ? value : storageValue }
                    required={required}
                    onChange={onChange}
                    autoComplete={label}
                    variant="standard"
                  />
                </FormControl>
              )}
            />
            <ErrorMessage
              errors={errors}
              name={name}
              render={({ message }) => (
                <span className={styles.form__error}>{message}</span>
              )}
            />
          </>
        )}
      </div>
    </div>
  );
};
